import { render, staticRenderFns } from "./phoneLogin.vue?vue&type=template&id=057de8e3"
import script from "./phoneLogin.vue?vue&type=script&lang=js"
export * from "./phoneLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports